import { Input } from '@thanx/uikit/input'
import { Text } from '@thanx/uikit/text'
import { alert } from 'actions/flash'
import { useRenameUserListMutation } from 'api/userLists'
import { getErrorMessage, isFetchBaseQueryError } from 'api/utils'
import Modal from 'components/ModalContainer'
import useDispatch from 'hooks/useDispatch'
import { buildTranslate } from 'locales'
import React, { useEffect, useState } from 'react'

const t = buildTranslate('user_lists.landing.rename_modal')

type Props = {
  isOpen: boolean
  onClose: () => void
  listId: string
  listName: string
}

const RenameListModal: React.FC<Props> = ({
  isOpen,
  onClose,
  listId,
  listName,
}) => {
  const dispatch = useDispatch()
  const [name, setName] = useState(listName)
  const [renameList, { isLoading }] = useRenameUserListMutation()

  useEffect(() => {
    if (isOpen) {
      setName(listName)
    }
  }, [isOpen, listName])

  const handleClose = () => {
    setName(listName)
    onClose()
  }

  const handleRename = async () => {
    if (!name.trim() || isLoading) return
    try {
      await renameList({ id: listId, name: name.trim() }).unwrap()
      onClose()
      dispatch(
        alert({
          key: 'success',
          message: t('success'),
          timeout: 5,
        })
      )
    } catch (error) {
      const message = isFetchBaseQueryError(error)
        ? getErrorMessage(error, t('error'))
        : t('error')
      dispatch(
        alert({
          key: 'danger',
          message,
          timeout: 5,
        })
      )
      onClose()
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      title={t('title')}
      proceedText={t('confirm')}
      onProceed={handleRename}
      onClose={handleClose}
      canProceed={!!name.trim() && !isLoading}
      isLoading={isLoading}
    >
      <div className="mt-m mb-xs">
        <Text.BodyText4 bold>{t('title')}</Text.BodyText4>
      </div>
      <Input
        size="default"
        placeholder={t('placeholder')}
        value={name}
        onChange={newName => setName(newName)}
        overrides={{
          Input: {
            style: () => ({
              fontSize: '16px !important',
            }),
          },
        }}
      />
    </Modal>
  )
}

export default RenameListModal
